import GeozoneDefaultIcon from "@images/default/geozone_default.svg";
import { useSelector } from "react-redux";

const GeozoneListImage = ({
  className,
  width = "20px",
  height = "20px",
  image,
  icon,
}) => {
  const language = useSelector((state) => state.language);
  const renderContent = () => {
    if (image && image !== "") {
      return (
        <img
          className={className}
          src={image}
          alt={language.image_key}
          width={width}
          height={height}
        />
      );
    }

    if (icon) {
      return (
        <img
          className={className}
          src={icon}
          alt={language.icon_key}
          width={width}
          height={height}
        />
      );
    }

    return (
      <img
        className={className}
        src={GeozoneDefaultIcon}
        alt={language.icon_key}
        width={width}
        height={height}
      />
    );
  };

  return <>{renderContent()}</>;
};

export default GeozoneListImage;
